import { Navigate, useNavigate } from "react-router-dom"
import AuthService from "../config/auth/auth.service";
import { useMsal } from "@azure/msal-react";

const PrivilegeRoute = ({ component, privilege }: any) => {
    const isPrivilege = AuthService.hasPrivilege(privilege);
    const navigate = useNavigate();
    const { instance } = useMsal();
    if (!isPrivilege) AuthService.logout(navigate, instance);
    return isPrivilege ? component : <Navigate to="/" replace />
}

export default PrivilegeRoute;